module.exports = ".ck-content .media{clear:both;margin:1em 0;display:table;min-width:15em;width:100%}"